import { render, staticRenderFns } from "./RareControlPanel.vue?vue&type=template&id=6b8678be&scoped=true"
import script from "./RareControlPanel.vue?vue&type=script&lang=js"
export * from "./RareControlPanel.vue?vue&type=script&lang=js"
import style0 from "./RareControlPanel.vue?vue&type=style&index=0&id=6b8678be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8678be",
  null
  
)

export default component.exports